import { FormGroup } from '@angular/forms';

export const isValidField = (
  form: FormGroup,
  field: string
): boolean | null => {
  return (form.get(field)?.errors && form.get(field)?.touched) ?? null;
};
